import {
  adjustTo25IfTodayIsAfter25,
  calculateEndDateFromGracePeriod,
  calculateFirstRentDateFromGracePeriod,
  calculateSecondRentDateFromGracePeriod,
  setGracePeriod
} from 'src/utils/contracts';
import momentLocalTimezone from 'src/utils/momentLocalTimezone';

export default (values, parameter) => {
  const gracePeriod =
    values.gracePeriod !== undefined
      ? Number(values.gracePeriod)
      : setGracePeriod(values, parameter);

  return {
    ...values,
    term: Number(values.term) || null,
    startDate: momentLocalTimezone(),
    firstRentDate: adjustTo25IfTodayIsAfter25(
      calculateFirstRentDateFromGracePeriod(
        momentLocalTimezone(),
        gracePeriod,
        values.isFirstUpfrontRentModality,
        Number(values.initialPayment)
      )
    ),
    secondRentDate:
      values.secondRentDate ||
      calculateSecondRentDateFromGracePeriod(
        momentLocalTimezone(),
        gracePeriod
      ),
    endDate: adjustTo25IfTodayIsAfter25(
      calculateEndDateFromGracePeriod(
        momentLocalTimezone(),
        Number(values.term),
        gracePeriod,
        values.isFirstUpfrontRentModality
      )
    ),
    sendToDigitalSign: true,
    payday: values.payday || Math.min(momentLocalTimezone().date(), 25)
  };
};
